import * as React from "react";
import { getUserCount } from "aws/lambda";

export const useUserCount = () => {
  const [userCount, setUserCount] = React.useState<number>(0);
  const [showUserCount, setShowUserCount] = React.useState(false);

  const fetchUserCount = async () => {
    const result = await getUserCount();
    console.log("user count result", result);

    if (result.error) {
      console.warn("User count fetch warning:", result.error);
      setShowUserCount(false);
    } else {
      setUserCount(result.count);
      setShowUserCount(true);
    }
  };

  // Hide User Count
  // React.useEffect(() => {
  //   fetchUserCount();
  //   const interval = setInterval(fetchUserCount, 5 * 60 * 1000);
  //   return () => clearInterval(interval);
  // }, []);

  return { userCount, showUserCount };
};
